import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {BaseInput} from "../input/BaseInput";
import {RootState} from "@/store/modules";
import {ModalType} from "./NewApplicationModal.tsx";
import {attribute} from "@/store/modules/attribute.ts";
import {DELETE_ATTRIBUTE, DeleteAttribute} from "@/model/request/attribute/DeleteAttribute.ts"
import {BaseResponse} from "@/model/response/BaseResponse.ts";


export default function DeleteAttributeModal({show, onClose}: ModalType) {
    const dispatch = useDispatch<any>();
    const entityState = useSelector((state: RootState) => state.entity);
    const AttributeState = useSelector((state: RootState) => state.attribute)
    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() => {
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
            onClose()
            dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState?.selectedEntity?.entityId ? entityState?.selectedEntity?.entityId : 0}))
        })
    };
    const handleSubmit = async (value: DeleteAttribute) => {
        const request = {
            ...value,
            attributeId: AttributeState.selectedAttribute?.attributeId ? AttributeState.selectedAttribute?.attributeId : 0,
        };
        await dispatch(attribute.action.delete({
            data: request,
            onSuccess: (response: BaseResponse) => {
                showSuccessMessage(response)
            },
            onError: (response: BaseResponse) => showErrorMessage(response),
        }))
        formik.resetForm();
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: DELETE_ATTRIBUTE,
    });
    return (

        <>
            {show &&
                <div className="modal1_component">
                    <div className="modal1_content-wrapper">
                        <div style={{backgroundColor: "white"}}>
                            <h5 className="delete">Delete Attribute</h5>
                            <div>
                                <div className="workspace-content">
                                    <p>Delete Attribute: {AttributeState.selectedAttribute?.attributeName}</p>
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="flex btns">
                                            <a className="button is-secondary w-button" onClick={onClose}>Cancel</a>
                                            <BaseInput
                                                type="submit"
                                                formik={formik}
                                                name={"submit"}
                                                value={"Delete"}
                                                loading={AttributeState.loading}
                                                className={"button w-button"}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal1_background-overlay"></div>
                        </div>
                    </div>
                </div>
            }
        </>

    );
}



